import { Component } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { AiChatComponent, ISelectOption } from '@core/components/ai-chat/ai-chat.component';
import { UserTypeEnum } from '@oranta-mis/sdk';
import { AiChatModelEnum } from '@core/enums/ai.enum';

@Component({
  selector: 'app-patient-ai-chat',
  imports: [AiChatComponent],
  templateUrl: './patient-ai-chat.component.html',
  styleUrl: './patient-ai-chat.component.scss',
})
@UntilDestroy()
export class PatientAiChatComponent {
  public select: ISelectOption[] = [{ value: AiChatModelEnum.patientAssistant1, label: 'patient_assistant' }];
  public readonly UserTypeEnum = UserTypeEnum;
}
